import React from "react";
import { getApplicantDocumentUrl } from "../../../utils/applicantSummary";
import logo from "../../../assets/img/MU LOGO.png";
import "./jamb-summary.css";

export function SummaryHeader() {
  return (
    <header className="jamb-summary-header">
      <img src={logo} alt="Maduka University logo" />
      <h1>MADUKA UNIVERSITY, Ekwegbe - Nsukka, Enugu State, Nigeria</h1>
      <h2>The Registrar&apos;s Office</h2>
      <p>JAMB Entry Application Summary</p>
    </header>
  );
}

export function SummarySection({ title, children }) {
  return (
    <section className="jamb-summary-section">
      <h3 className="jamb-summary-section-title">{title}</h3>
      {children}
    </section>
  );
}

export function DetailGrid({ children }) {
  return <dl className="jamb-summary-detail-grid">{children}</dl>;
}

export function DetailRow({ label, value }) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  return (
    <div className="jamb-summary-detail-row">
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  );
}

export function SubCard({ title, children }) {
  return (
    <article className="jamb-summary-subcard">
      <h4>{title}</h4>
      <DetailGrid>{children}</DetailGrid>
    </article>
  );
}

export function DocumentItem({ label, document }) {
  const url = getApplicantDocumentUrl(document);

  return (
    <div className="jamb-summary-document-item">
      <span>{label}</span>
      {url ? (
        <a href={url} target="_blank" rel="noopener noreferrer">
          View document
        </a>
      ) : (
        <span className="is-disabled">Not uploaded</span>
      )}
    </div>
  );
}

export function PassportPhoto({ document, alt }) {
  const url = getApplicantDocumentUrl(document);

  return (
    <div className="jamb-summary-passport">
      {url ? (
        <img src={url} alt={alt || "Passport photograph"} />
      ) : (
        <img src={logo} alt="Placeholder" style={{ objectFit: "contain", padding: "1rem" }} />
      )}
    </div>
  );
}
